import {
    CONTEST_LIST_REQUEST, CONTEST_LIST_SUCCESS, CONTEST_LIST_FAIL,
    CONTEST_DETAILS_REQUEST, CONTEST_DETAILS_SUCCESS, CONTEST_DETAILS_FAIL, CONTEST_DETAILS_RESET,
    CONTEST_CREATE_REQUEST, CONTEST_CREATE_SUCCESS, CONTEST_CREATE_FAIL, CONTEST_CREATE_RESET,
    CONTEST_UPDATE_REQUEST, CONTEST_UPDATE_SUCCESS, CONTEST_UPDATE_FAIL, CONTEST_UPDATE_RESET,
    CONTEST_DELETE_REQUEST, CONTEST_DELETE_SUCCESS, CONTEST_DELETE_FAIL,
} from '../constants/contestConstants'


export const contestListReducer = (state = { contests: [] }, action) => {
    switch (action.type) {
        case CONTEST_LIST_REQUEST: return { loading: true, contests: [] }
        case CONTEST_LIST_SUCCESS: return { loading: false, contests: action.payload }
        case CONTEST_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const contestDetailsReducer = (state = { contest: {} }, action) => {
    switch (action.type) {
        case CONTEST_DETAILS_REQUEST: return { loading: true, contest: {} }
        case CONTEST_DETAILS_SUCCESS: return { loading: false, contest: action.payload }
        case CONTEST_DETAILS_FAIL:    return { loading: false, error: action.payload }
        case CONTEST_DETAILS_RESET:   return { contest: {} }
        default: return state
    }
}

export const contestCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case CONTEST_CREATE_REQUEST: return { loading: true }
        case CONTEST_CREATE_SUCCESS: return { loading: false, success: true, contest: action.payload }
        case CONTEST_CREATE_FAIL:    return { loading: false, error: action.payload }
        case CONTEST_CREATE_RESET:   return {}
        default: return state
    }
}

export const contestUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case CONTEST_UPDATE_REQUEST: return { loading: true }
        case CONTEST_UPDATE_SUCCESS: return { loading: false, success: true, contest: action.payload }
        case CONTEST_UPDATE_FAIL:    return { loading: false, error: action.payload }
        case CONTEST_UPDATE_RESET:   return {}
        default: return state
    }
}

export const contestDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case CONTEST_DELETE_REQUEST: return { loading: true }
        case CONTEST_DELETE_SUCCESS: return { loading: false, success: true }
        case CONTEST_DELETE_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}
